/**
 * Heading typography components
 *
 * @example
 * ```tsx
 * <Heading3XL>Main Title</Heading3XL>
 * <HeadingL color="secondary" hasEllipsis>Subtitle</HeadingL>
 * ```
 */

import { TYPOGRAPHY_VARIANTS } from './config';
import { createTypographyComponent } from './Factory';

/**
 * Heading3XL - Largest heading (40px, h1)
 */
export const Heading3XL = createTypographyComponent(
	'Heading3XL',
	TYPOGRAPHY_VARIANTS.Heading3XL
);

/**
 * Heading2XL - Extra large heading (36px, h2)
 */
export const Heading2XL = createTypographyComponent(
	'Heading2XL',
	TYPOGRAPHY_VARIANTS.Heading2XL
);

/**
 * HeadingXL - Extra large heading (32px, h3)
 */
export const HeadingXL = createTypographyComponent(
	'HeadingXL',
	TYPOGRAPHY_VARIANTS.HeadingXL
);

/**
 * HeadingL - Large heading (24px, h4)
 */
export const HeadingL = createTypographyComponent(
	'HeadingL',
	TYPOGRAPHY_VARIANTS.HeadingL
);

/**
 * HeadingM - Medium heading (20px, h5)
 */
export const HeadingM = createTypographyComponent(
	'HeadingM',
	TYPOGRAPHY_VARIANTS.HeadingM
);

/**
 * HeadingS - Small heading (18px, h6)
 */
export const HeadingS = createTypographyComponent(
	'HeadingS',
	TYPOGRAPHY_VARIANTS.HeadingS
);

/**
 * HeadingXS - Extra small heading (16px, span)
 */
export const HeadingXS = createTypographyComponent(
	'HeadingXS',
	TYPOGRAPHY_VARIANTS.HeadingXS
);
